import { extract } from '../extractors/protocolFundamentals';
import { fmtUSD, fmtPct } from '../extractors/_shared';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function getProtocolEvidence(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d) return [];
  const rows = [];
  if (d.perpVolume24h != null)
    rows.push({ label: txt(lang, '永续24h成交', 'Perp 24h Vol'), val: fmtUSD(d.perpVolume24h), source: 'Artemis', positive: true });
  if (d.totalOI != null)
    rows.push({ label: txt(lang, '总持仓量(OI)', 'Total OI'), val: fmtUSD(d.totalOI), source: 'Artemis' });
  if (d.stakedHype != null)
    rows.push({ label: txt(lang, '质押 HYPE', 'Staked HYPE'), val: `${d.stakedHype.toLocaleString()} HYPE`, source: 'Artemis', positive: true });
  if (d.fundingRate != null)
    rows.push({ label: txt(lang, '资金费率', 'Funding Rate'), val: `${(d.fundingRate*100).toFixed(4)}%`, source: 'CoinGlass', positive: d.fundingRate >= 0 });
  if (d.longShortRatio != null)
    rows.push({ label: txt(lang, '多空比', 'L/S Ratio'), val: d.longShortRatio.toFixed(2), source: 'CoinGlass' });
  return rows;
}

export function ProtocolFundamentalsCard({ project, a, lang = 'zh', S, C }) {
  const d = extract(project, a);
  if (!d) return null;

  const cell = (label, value) => value == null ? null : (
    <div>
      <div style={{ fontSize: 10, color: C?.muted || '#6b7280' }}>{label}</div>
      <div style={{ fontSize: 14, fontWeight: 700 }}>{value}</div>
    </div>
  );

  return (
    <div style={S?.card || { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: C?.muted || '#6b7280', marginBottom: 10, textTransform: 'uppercase' }}>
        ⚡ {txt(lang, '协议基本面', 'Protocol Fundamentals')}
        <span style={{ marginLeft: 8, fontWeight: 400, fontSize: 9, color: '#94a3b8' }}>{d.source}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
        {cell(txt(lang, '永续24h成交', 'Perp Vol 24h'), d.perpVolume24h != null ? fmtUSD(d.perpVolume24h) : null)}
        {cell(txt(lang, '总持仓量', 'Total OI'),       d.totalOI != null ? fmtUSD(d.totalOI) : null)}
        {cell(txt(lang, '活跃市场', 'Active Markets'), d.activeMarkets)}
        {cell(txt(lang, '30日手续费', '30d Fees'),     d.perpFees30d != null ? fmtUSD(d.perpFees30d) : null)}
        {d.revenue30d != null && (
          <div>
            <div style={{ fontSize: 10, color: C?.muted || '#6b7280' }}>{txt(lang, '30日收入', '30d Revenue')}</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#2563eb' }}>{fmtUSD(d.revenue30d)}</div>
          </div>
        )}
        {cell(txt(lang, '质押 HYPE', 'Staked HYPE'),   d.stakedHype != null ? `${d.stakedHype.toLocaleString()} HYPE` : null)}
      </div>

      {d.topAssets.length > 0 && (
        <div style={{ marginTop: 14 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: C?.muted || '#6b7280', marginBottom: 8, textTransform: 'uppercase' }}>
            {txt(lang, '热门市场（24h成交量）', 'Top Markets (24h Volume)')}
          </div>
          <table style={{ width: '100%', fontSize: 11, borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#f9fafb', color: C?.muted || '#6b7280' }}>
              <th style={{ padding: '4px 6px', textAlign: 'left' }}>{txt(lang, '资产', 'Asset')}</th>
              <th style={{ padding: '4px 6px', textAlign: 'right' }}>{txt(lang, '24h成交', 'Vol 24h')}</th>
              <th style={{ padding: '4px 6px', textAlign: 'right' }}>OI</th>
              <th style={{ padding: '4px 6px', textAlign: 'right' }}>{txt(lang, '资金费率', 'Funding')}</th>
            </tr></thead>
            <tbody>
              {d.topAssets.map((t, i) => (
                <tr key={i} style={{ borderBottom: `1px solid ${C?.faint || '#f3f4f6'}` }}>
                  <td style={{ padding: '4px 6px', fontWeight: 600 }}>{t?.name || t?.coin}</td>
                  <td style={{ padding: '4px 6px', textAlign: 'right' }}>{t?.volume24h != null ? fmtUSD(t.volume24h) : '—'}</td>
                  <td style={{ padding: '4px 6px', textAlign: 'right' }}>{t?.openInterest != null ? fmtUSD(t.openInterest) : '—'}</td>
                  <td style={{ padding: '4px 6px', textAlign: 'right', color: (t?.funding || 0) >= 0 ? '#059669' : '#dc2626' }}>
                    {t?.funding != null ? (t.funding * 100).toFixed(4) + '%' : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {(d.fundingRate != null || d.openInterest != null || d.longShortRatio != null) && (
        <div style={{ marginTop: 14, paddingTop: 10, borderTop: `1px solid ${C?.faint || '#f3f4f6'}` }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: C?.muted || '#6b7280', marginBottom: 6, textTransform: 'uppercase' }}>
            📈 {txt(lang, '永续合约信号', 'Futures Signals')}
            <span style={{ marginLeft: 6, fontWeight: 400, fontSize: 9, color: '#94a3b8' }}>{d.futuresSource}</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            {d.fundingRate != null && (
              <div>
                <div style={{ fontSize: 10, color: C?.muted || '#6b7280' }}>{txt(lang, '资金费率', 'Funding Rate')}</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: d.fundingRate >= 0 ? '#059669' : '#dc2626' }}>{(d.fundingRate * 100).toFixed(4)}%</div>
              </div>
            )}
            {d.openInterest != null && cell(txt(lang, '总持仓', 'Open Interest'), fmtUSD(d.openInterest))}
            {d.longShortRatio != null && cell(txt(lang, '多空比', 'L/S Ratio'), d.longShortRatio.toFixed(2))}
          </div>
        </div>
      )}
    </div>
  );
}
